module.exports = __webpack_public_path__ + "7d088296/img/chevron-down-icon.5542f65c.svg";